import { WorkOrderObservation } from '@/core/domain/workorder/WorkOrdersObservations/WorkOrdersObservations.types';
import { Form } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import React, { useEffect } from 'react';
interface Props {
  observationsRows?: number;
  observations?: WorkOrderObservation[];
}

const MechanicsRecordVehicleObservations: React.FC<Props> = ({
  observationsRows,
  observations,
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (!!observations?.length) {
      form.setFieldValue(
        'observations',
        observations.map(({ observation }) => observation).join('\n'),
      );
    }
  }, [observations]);

  return (
    <Form form={form}>
      <table className="vehicle-info-parts">
        <thead>
          <tr>
            <th>Observações</th>
            <th>Câmbio</th>
            <th>Blindado</th>
          </tr>
        </thead>

        <tbody>
          <tr>
            <td>
              <Form.Item name="observations" noStyle>
                <TextArea rows={observationsRows || 6} />
              </Form.Item>
            </td>

            <td>
              <label>
                <span>MEC:</span>
                <input type="checkbox" />
              </label>

              <label>
                <span>AUT:</span>
                <input type="checkbox" />
              </label>
            </td>

            <td>
              <label>
                <span>SIM:</span>
                <input type="checkbox" />
              </label>

              <label>
                <span>NÃO:</span>
                <input type="checkbox" />
              </label>
            </td>
          </tr>
        </tbody>
      </table>
    </Form>
  );
};

export default MechanicsRecordVehicleObservations;
